import React from 'react'
import {
  TextInput,
  BooleanInput,
} from 'react-admin'
import { Box } from '@material-ui/core'
import {
  formInputOptions,
} from '../../util/component-options'
import { useFormStyles } from '../../../styles'
import { useLabel } from '../../../hooks'
import { Form, getValidator } from '../../form'
import { AddressInputFields } from '../../shared'

const CompaniesForm = props => {
  const { resource } = props
  const formClasses = useFormStyles(props)
  const label = useLabel(props)

  return (
    <Form
      {...props}
    >
      <Box className={formClasses.grid}>
        <Box>
          <TextInput
            {...formInputOptions}
            source='name'
            label={label('name')}
            validate={getValidator()}
            required
          />

          <TextInput
            {...formInputOptions}
            source='email'
            label={label('email')}
            validate={getValidator(false)}
          />

          <TextInput
            {...formInputOptions}
            source='phone_number'
            label={label('phone_number')}
            validate={getValidator(false)}
          />

          <TextInput
            {...formInputOptions}
            source='ledger_code'
            label={label('ledger_code')}
            validate={getValidator(false)}
          />

          <TextInput
            {...formInputOptions}
            source='federal_id_number'
            label={label('federal_id_number')}
            validate={getValidator(false)}
          />

          <BooleanInput
            source='uses_consolidated_invoices'
            label={label('uses_consolidated_invoices')}
            defaultValue={false}
          />

        </Box>

        <Box>
          <AddressInputFields resource={resource} addressRequired={false} prefix='billing_address' />
        </Box>
      </Box>
    </Form>
  )
}

export default CompaniesForm
